export default __webpack_public_path__ + "static/media/circle01.c5309a22.svg";